/**
 * FloatingCard — Rounded card with border and shadow
 * Used in Practice-style screens for standalone content cards
 */

import React from 'react';
import { Box, Text } from '@gluestack-ui/themed';
import { useDisplayTheme } from '../../hooks/useDisplayTheme';

const BASE_TITLE_SIZE = 16;

interface FloatingCardProps {
  children: React.ReactNode;
  title?: string;
  /** Horizontal margin token, defaults to "$5" */
  mx?: string;
  /** Top margin token */
  mt?: string;
  /** Padding token, defaults to "$5" */
  p?: string;
  testID?: string;
}

export function FloatingCard({
  children,
  title,
  mx = '$5',
  mt,
  p = '$5',
  testID,
}: FloatingCardProps) {
  const { theme: t, fontScale, ffs } = useDisplayTheme();

  return (
    <Box
      testID={testID}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Gluestack spacing tokens are narrowly typed
      mx={mx as any} mt={mt as any} p={p as any}
      rounded="$2xl"
      style={{ backgroundColor: t.card, borderWidth: 1, borderColor: t.border }}
    >
      {title && (
        <Text
          allowFontScaling={false}
          accessibilityRole="header"
          mb="$4"
          style={{ fontSize: BASE_TITLE_SIZE * fontScale, fontWeight: 'bold', color: t.text, ...ffs }}
        >
          {title}
        </Text>
      )}
      {children}
    </Box>
  );
}
